<template>
    <body class="site-body">
        <div v-if="!siteDesign || (requestBusy && !requestOverlayText)" id="loading-overlay">
            <div class="loader"></div>
        </div>
        <div v-if="requestOverlayText" id="request-overlay" class="modal in accent-secondary-bg" tabindex="-1" role="dialog" aria-hidden="true" style="display:block; z-index: 99999; background-color: #16093dfa">
            <div style="margin-top: 15vh">
                <div>
                    <div style="text-align: center">
                        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <br />
                        <br />
                        <p class="text-white">{{ requestOverlayText }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="requestErrorCode !== null" id="request-error-overlay" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
            <div style="margin-top: 12vh">
                <div>
                    <div style="text-align: center">
                        <div v-if="requestErrorCode == 0">
                            <p class="error-title">Network Connection Error</p>
                            <p class="error-description">We're having trouble processing your request. Please check your internet connection and try again</p>
                            <button class="btn btn-danger" v-on:click="$router.go()">Retry</button>
                        </div>
                        <div v-else-if="requestErrorCode == 404">
                            <p class="error-title">Resource not found</p>
                            <p class="error-description">We could not locate the resource you requested</p>
                            <router-link class="btn btn-danger" to="/">Take me home!</router-link>
                        </div>
                        <div v-else>
                            <p class="error-title">Error: {{ requestErrorCode }}</p>
                            <p class="error-description">We're having trouble processing your request. Please try again and contact our support team at support@elevatex.tech if the issue persists.</p>
                            <button class="btn btn-danger" v-on:click="$router.go()">Retry</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <header-component v-if="siteDesign" />
        <router-view v-if="siteDesign" />
        <footer id="footer" class="footer-type1 footer-bg" v-if="siteDesign">
            <div id="contact-saica" class="title-section d-flex" style="padding-left: 25px">
                <div class="flat-title small footer-tx pt-3">
                    Contact Us
                </div>
                <div class="accent-primary-bd-bottom ml-2" style="width: 50px;"></div>
            </div>

            <div class="form-send-email">

                <form v-if="!contactSubmissionSucceeded" class="" action="/#">
                    <div class="row">
                        <div class="col-12">
                            <div class="container-fluid ml-auto mr-auto" style="max-width: 800px;">
                                <div class="row">
                                    <div class="col-sm-6 col-12">
                                        <input class="form-send" type="text" placeholder="First Name" v-model="contactFirstName">
                                        <input class="form-send" type="email" placeholder="Email" v-model="contactEmail">
                                    </div>
                                    <div class="col-sm-6 col-12">
                                        <input class="form-send" type="text" placeholder="Surname" v-model="contactLastName">
                                        <input class="form-send" type="number" placeholder="Number" v-model="contactNumber">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12">
                                        <textarea class="form-send" type="text" placeholder="Your message" v-model="contactMessage" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-wrapper">
                        <button type="button" class="contact-btn btn-site-primary" style="margin-top: 20px;" v-on:click="submitContactForm()">
                            Send
                        </button>
                    </div>
                </form>
                <div v-else class="ty-wrapper">
                    <div class="footer-tx">Thank you for contacting us! <br />We'll be in contact soon.</div>
                </div>

            </div>
            <div id="footer-widget" v-if="siteDesign">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-3 col-12 col-footer">
                            <div class="logo-footer">
                                <img :src="'https://fabricfour.blob.core.windows.net/mhslearning-upload/' + siteDesign.footer.logoFileName" alt="images" style="max-width: 200px;">
                            </div>
                        </div>
                        <div class="col-lg-3 col-12 col-company" v-if="siteDesign.footer.address">
                            <div>
                                <h3 class="widget widget-title footer-tx">
                                    Address
                                </h3>
                                <div class="footer-address">
                                    <!--format later-->
                                    <p class="footer-tx">{{siteDesign.footer.address}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-12 col-company">
                            <h3 class="widget widget-title footer-tx">
                                Contact
                            </h3>
                            <div class="footer-address">
                                <p><a href="#" class="sl-phone footer-tx">{{siteDesign.footer.contactNumber}}</a></p>
                                <p><a href="#" class="sl-email footer-tx">{{siteDesign.footer.email}}</a></p>
                            </div>
                        </div>
                        <div class="col-lg-3 col-12 col-media">
                            <h3 class="widget widget-title footer-tx">
                                About
                            </h3>
                            <div class="footer-address">
                                <p><a class="footer-tx" :href="siteDesign.footer.aboutUrl ? siteDesign.footer.aboutUrl : '#'" target="_blank">{{'About ' + documentTitle}}</a></p>
                                <p><a class="footer-tx" v-if="siteDesign.footer.termsFileName !== ''" target="_blank" :href="siteDesign.footer | s3url('terms')">Terms</a></p>
                                <p><a class="footer-tx" v-if="siteDesign.footer.privacyPolicyFileName !== ''" target="_blank" :href="siteDesign.footer | s3url('privacyPolicy')">Privacy Policy</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="bottom" class="bottom-type1 clearfix has-spacer" v-if="siteDesign">
                <div id="bottom-bar-inner" style="padding-left: 15px; padding-right: 15px;">
                    <div class="bottom-bar-inner-wrap" style="border-top: none;">
                        <div class="bottom-bar-content" style="color: white !important">
                            <div class="row">
                                <div class="col-lg-6 col-12" style="padding-top: 2%;">
                                    <div id="copyright" style="text-align: center;">
                                        <span class="text-name footer-tx">
                                            {{documentTitle}}
                                        </span>
                                        <span class="license">
                                            <a href="#" class="footer-tx">| All Rights Reserved </a>
                                        </span>
                                        <a v-if="siteDesign.footer.termsFileName !== ''" style="color: #7a7a7a; font-size: 14px;" :href="siteDesign.footer | s3url('terms')" class="footer-tx" target="_blank">| Terms & conditions</a>
                                        <a v-if="siteDesign.footer.privacyPolicyFileName !== ''" style="color: #7a7a7a; font-size: 14px;" class="footer-tx" :href="siteDesign.footer | s3url('privacyPolicy')" target="_blank">| Privacy Policy</a>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12">
                                    <div v-if="siteDesign.paygateId">
                                        <img src="/wwwroot/images/footer/paygate-logo-new.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a id="scroll-top" class="show"></a>
        </footer><!-- footer -->
    </body>
</template>


<script>
    import HeaderComponent from "./components/HeaderComponent";

    export default {
        name: 'app',
        components: { HeaderComponent },
        data() {
            return {
                courses: [],
                coursePackages: [],

                contactFirstName: "",
                contactLastName: "",
                contactEmail: "",
                contactNumber: "",
                contactMessage: "",
                contactSubmissionSucceeded: false,
            }
        },
        methods: {
            async submitContactForm() {

                await this.web("/contact", "Submitting your form", {
                    contactFirstName: this.contactFirstName,
                    contactLastName: this.contactLastName,
                    contactEmail: this.contactEmail,
                    contactNumber: this.contactNumber,
                    contactMessage: this.contactMessage
                });

                this.contactSubmissionSucceeded = true;
            },
            
        },
        watch: {
        },
        computed: {
            requestOverlayText() { return this.$store.state.requestOverlayText; },
            requestErrorCode() { return this.$store.state.requestErrorCode; },
            requestBusy() { return this.$store.state.requestBusy; },
            siteDesign() {
                return this.$store.getters.getSiteDesign;
            },
            user() {
                var user = this.$store.getters.getUser;
                return user;
            },
            documentTitle() {
                var title = document.title;
                return title;
            }
        },
        mounted() {
        },
        async created() {
            //this.$nextTick(() => {
            //    this.setTheme();
            //})
        }
    }
</script>

<style>

    #footer input {
        background-color: white !important;
        border: 1px solid black !important;
    }

    #footer textarea {
        background-color: white !important;
        border: 1px solid black !important;
        max-width: 100% !important;
    }

    #footer ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: black;
        opacity: 1; /* Firefox */
    }

    #footer :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: black;
    }

    #footer ::-ms-input-placeholder { /* Microsoft Edge */
        color: black;
    }

    #request-error-overlay {
        display: block;
        z-index: 99999;
        background-color: #620d0dfa;
    }

    .error-title {
        color: white;
        font-size: 24px;
    }

    .error-description {
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 18px;
    }
</style>
